var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title'),(_vm.objectives)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.objectives,"items-per-page":25}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }